class AdminController { }

export default AdminController;



// WEBPACK FOOTER //
// ./app/admin/admin.controller.js